var _path, _ellipse, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCouponUtilized = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 50,
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
  fill: "#BCD9C9"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.7141,
  cy: 25,
  rx: 15.8571,
  ry: 17.1429,
  fill: "white"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 17.25,
  stroke: "#727D79",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 24C26.6569 24 28 22.6569 28 21C28 19.3431 26.6569 18 25 18C23.3431 18 22 19.3431 22 21C22 22.6569 23.3431 24 25 24Z",
  stroke: "#FF8B22",
  strokeWidth: 1.8
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M32 33C32 29.134 28.866 26 25 26C21.134 26 18 29.134 18 33",
  stroke: "#FF8B22",
  strokeWidth: 1.8,
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCouponUtilized);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-coupon-utilized.8b0059f49e47c36ed25e558b902cb576.svg";